import {useEffect} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {event, EVENT_TYPES} from '../utils/event';

const useEvent = () => {
	const {
		config: {
			data: configData,
			isRequested,
		},
	} = useSelector((state) => state, shallowEqual);

	// MyAccount: using teams data
	useEffect(() => {
		const dispatchConfig = () => {
			event.trigger(EVENT_TYPES.CONFIG_DATA_DISPATCH, configData);
		};
		if (isRequested) {
			event.trigger(EVENT_TYPES.CONFIG_DATA_READY, configData);
			event.on(EVENT_TYPES.CONFIG_DATA_GET, dispatchConfig);
		}
		return () => {
			if (isRequested) {
				event.off(EVENT_TYPES.CONFIG_DATA_GET, dispatchConfig);
			}
		};
	}, [configData, isRequested]);

	// Player: Free sample end event
	useEffect(() => {
		const freeSampleEndForPlayer = () => {
			event.trigger(EVENT_TYPES.PLAYER_EXIT_FULL_SCREEN);
			event.trigger(EVENT_TYPES.PLAYER_STOP_PLAY);
		};
		event.on(EVENT_TYPES.FREE_SAMPLE_END, freeSampleEndForPlayer);

		return () => {
			event.off(EVENT_TYPES.FREE_SAMPLE_END, freeSampleEndForPlayer);
		};
	}, []);
};

export default useEvent;
